import { Component, OnInit } from '@angular/core';
import { AccountService } from 'src/app/services/account.service';
import { ActivatedRoute } from '@angular/router';
import { FormResponse } from 'src/models/form-response';
import { AlertBoxType } from '../base/alert-box/alertboxtype';
import { FormResponseError } from 'src/models/form-response-error';

@Component({
  selector: 'app-confirm-registration',
  templateUrl: './confirm-registration.component.html',
  styleUrls: ['./confirm-registration.component.scss']
})
export class ConfirmRegistrationComponent implements OnInit {

  private email: string;
  private confirmHash: string;

  public confirmed: boolean;
  public errors: FormResponseError[];

  public alertBoxTypes = AlertBoxType;

  constructor(private activatedRoute: ActivatedRoute, private accountService: AccountService) {
    this.activatedRoute.queryParams.subscribe(params => {
        this.email = params['email'];
        this.confirmHash = params['regkey'];
    });

    this.errors = [];
  }

  ngOnInit(): void {
    this.accountService.confirm(this.email, this.confirmHash).subscribe((formResponse: FormResponse) => {
      this.confirmed = formResponse.result;
      this.errors = formResponse.errors;
    });
  }

}
